import styles from './styles.module.css';

export default function SecondSubfooter() {
  return (
    <section
      className={styles.second_subfooter}
      aria-label="Address and copyright info"
    >
      <address>
        QubicaAMF Europe spa - Via della Croce Coperta, 15 40128 Bologna, Italy
        - VAT IT04320910377
      </address>
      <p>Copyright © 2025 Qubica Holdings s.r.l. All rights reserved.</p>
    </section>
  );
}
